/**
 * Onboarding Enlist — V16 录取通知书弹窗
 *
 * 职责：
 *   - 渲染 Ardot 风格军事文书弹窗
 *   - 姓名铭刻（预填「张宁」，可编辑）
 *   - 确认报到 → 返回用户姓名
 *
 * 纯 DOM 渲染，无框架依赖。
 */

import { startOnboarding, setOnboardingPlayerName } from "./onboarding-state";

/** 预填姓名 */
const DEFAULT_NAME = "张宁";

/**
 * 渲染录取通知书弹窗
 * @param container 父容器（通常是 #app）
 * @returns Promise<string> 用户确认后的姓名
 */
export function renderEnlistment(container: HTMLElement): Promise<string> {
  return new Promise((resolve) => {
    // 创建覆盖层
    const overlay = document.createElement("div");
    overlay.className = "onboarding-enlist-overlay";
    overlay.innerHTML = `
      <div class="onboarding-enlist-modal">
        <button class="onboarding-enlist-back" title="返回首页">← 返回</button>
        <div class="onboarding-enlist-header">
          <div class="onboarding-enlist-org">◤ 磐石指挥部 ◥</div>
          <div class="onboarding-enlist-program">▎承刃计划 · 第七期</div>
          <div class="onboarding-enlist-deco">◣ ◆ ◆ ◆ ◆ ◆ ◆ ◢</div>
        </div>
        <div class="onboarding-enlist-body">
          <div class="onboarding-enist-rail">▎</div>
          <div class="onboarding-enlist-content">
            <p class="onboarding-enlist-line">兹录取</p>
            <div class="onboarding-enlist-name-box">
              <input type="text" class="onboarding-enlist-name-input" value="${DEFAULT_NAME}" maxlength="6" autocomplete="off" />
            </div>
            <p class="onboarding-enlist-line">为第七期承刃计划战术推演官</p>
            <p class="onboarding-enlist-line">请铭刻姓名以确认</p>
          </div>
        </div>
        <div class="onboarding-enlist-footer">
          <div class="onboarding-enlist-meta">
            <span>编号：CH-00-07-0421</span>
            <span class="onboarding-enlist-divider">|</span>
            <span>密级：磐石</span>
          </div>
          <button class="onboarding-enlist-confirm">确认报到</button>
        </div>
      </div>
    `;
    container.appendChild(overlay);

    const nameInput = overlay.querySelector(".onboarding-enlist-name-input") as HTMLInputElement;
    const confirmBtn = overlay.querySelector(".onboarding-enlist-confirm") as HTMLButtonElement;
    const backBtn = overlay.querySelector(".onboarding-enlist-back") as HTMLButtonElement;

    // 确认报到
    confirmBtn.addEventListener("click", () => {
      const name = nameInput.value.trim() || DEFAULT_NAME;
      startOnboarding(name);
      setOnboardingPlayerName(name);
      overlay.remove();
      resolve(name);
    });

    // 返回首页
    backBtn.addEventListener("click", () => {
      overlay.remove();
      resolve(""); // 空字符串表示取消
    });

    // Enter 键确认
    nameInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        confirmBtn.click();
      }
    });

    // 自动聚焦
    requestAnimationFrame(() => nameInput.focus());
    nameInput.select();
  });
}
